module.exports = __webpack_public_path__ + "static/snowball-empty-phone-e6916b4a9454ed51ad5b3e208a92efc9.png";